import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import dayjs from 'dayjs';

import { Link } from 'react-router-dom';

import SVG from 'components/SVG';

import editSVG from 'features/bonusProgram/data/img/edit-alt.svg';
import closeSVG from 'features/bonusProgram/data/img/close.svg';

import { convertLangById } from 'shared/helpers';

import './TableRow.scss';

const TableRow = ({ item, locale, handleDeletePromotion }) => {
  const b = block('table-row-bonus');

  const isActive = useMemo(() => {
    switch (item.isActive) {
      case true:
        return locale.yes;
      case false:
        return locale.no;
      default:
        return '';
    }
  }, [item, locale]);

  return (
    <div className={b()}>
      <div className={b('td')}>
        <span className={b('td-value')}>
          <img className={b('td-value-image')} src={`https://ganamos.net/${item.urlImage}`} alt="" />
        </span>
      </div>
      <div className={b('td', { long: true })}>
        <span className={b('td-value')}>{item.url}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item?.publicationDate}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item?.selfDeletionDate}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{locale[convertLangById(item.lang)]}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{isActive}</span>
      </div>
      <div className={b('td')}>
        <div className={b('td-actions')}>
          <Link to={`/bonus-promo/promotions/create/${item.id}`}>
            <SVG className={b('td-actions-icon')} svgProps={{ svg: editSVG }} />
          </Link>
          <SVG
            onClick={() => handleDeletePromotion(item.id)}
            className={b('td-actions-icon')}
            svgProps={{ svg: closeSVG }}
          />
        </div>
      </div>
    </div>
  );
};

TableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TableRow;
